import { ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

declare module '@mui/material/TextField' {
  // tslint:disable-next-line:interface-name
  interface TextFieldPropsSizeOverrides {
    large: true;
  }

  // tslint:disable-next-line:interface-name
  interface BaseTextFieldProps {
    naked?: boolean;
  }
}

export const MuiTextField: ThemeOptions['components']['MuiTextField'] = {
  defaultProps: {
    InputLabelProps: {
      shrink: true
    },
    rows: 3
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      textarea: {
        cursor: 'pointer'
      },
      maxWidth: '100%',
      '.MuiInputLabel-root, .MuiInputLabel-root.Mui-focused': {
        color: 'inherit',
        position: 'relative',
        transform: 'none',
        '&.MuiInputLabel-outlined': {
          ...(ownerState.size === 'small' && {
            fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall
          }),
          ...(ownerState.size === 'large' && {
            fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault
          })
        }
      },
      '.MuiInputLabel-root.Mui-error, .MuiInputLabel-root.Mui-disabled': {
        color: theme.palette.text.primary
      },
      '.MuiInputBase-multiline': {
        cursor: 'pointer',
        maxWidth: '100%',
        width: '320px',
        height: 'inherit',
        ...(ownerState.size === 'small' && {
          height: 'inherit'
        }),
        ...(ownerState.size === 'large' && {
          height: 'inherit'
        }),
        alignItems: 'flex-start',
        '.MuiInputAdornment-root': {
          maxHeight: '100%',
          height: '100%'
        }
      },
      '.MuiInputAdornment-root': {
        color: theme.palette.text.secondary,
        button: {
          color: 'inherit'
        }
      },
      'input[type="number"]': {
        MozAppearance: 'textfield',
        '&:hover, &:focus': {
          MozAppearance: 'initial'
        }
      },
      '.Mui-readOnly': {
        color: theme.palette.text.disabled,
        background: theme.palette.action.hover,
        '.MuiInputBase-multiline': {
          padding: theme.spacing(2)
        }
      }
    })
  },
  variants: [
    {
      props: { naked: true, multiline: true, variant: 'outlined' },
      style: ({ theme }) => ({
        fieldset: {
          borderLeftColor: theme.palette.outline ?? theme.palette.divider,
          borderTopColor: 'transparent',
          borderRightColor: 'transparent',
          borderBottomColor: 'transparent',
          borderRadius: 0
        },
        // Display all borders for naked TextArea with icon
        '.MuiInputBase-adornedEnd .MuiOutlinedInput-notchedOutline': {
          borderTopColor: theme.palette.outline ?? theme.palette.divider,
          borderRightColor: theme.palette.outline ?? theme.palette.divider,
          borderBottomColor: theme.palette.outline ?? theme.palette.divider,
          borderRadius: capitalDesignTokens.foundations.units.unitHalf
        }
      })
    }
  ]
};
